import React from 'react'
import playerApi from '../utils/playerApi'

export default function withPlayerApi(WrappedComponent) {
  const WithPlayerApi = props => <WrappedComponent playerApi={playerApi()} {...props} />

  WithPlayerApi.getInitialProps = async (ctx) => {
    let pageProps = {}
    if (WrappedComponent.getInitialProps) {
      pageProps = await WrappedComponent.getInitialProps({
        ...ctx,
        playerApi: playerApi(ctx),
      })
    }

    return {
      ...pageProps,
      playerApi: playerApi(ctx),
    }
  }

  return WithPlayerApi
}
